export default __webpack_public_path__ + "static/media/user.c6722e1b.svg";